var exports = {
  "i": "xfd349460--005833--wrapper",
};

module.exports = exports;
